import { createAsyncAction, createStandardAction } from 'typesafe-actions';

export interface UploadFileActionProps {
  fileUploadId: string;
  uploadUrl: string;
  localUrl: string;
  file: File;
}
export interface UploadPresentationFileActionProps
  extends UploadFileActionProps {
  presentationId: string;
  path: Array<string | number>;
}

export const uploadFile =
  createStandardAction('UPLOAD_FILE')<UploadFileActionProps>();

export const uploadPresentationFile = createStandardAction(
  'UPLOAD_PRESENTATION_FILE',
)<UploadPresentationFileActionProps>();

export const uploadFileAsync = createAsyncAction(
  'UPLOAD_FILE_REQUEST',
  'UPLOAD_FILE_SUCCESS',
  'UPLOAD_FILE_FAILURE',
)<
  {
    fileUploadId: string;
    localUrl: string;
  },
  { fileUploadId: string },
  { fileUploadId: string; error: Error }
>();

export const uploadPresentationFileAsync = createAsyncAction(
  'UPLOAD_PRESENTATION_FILE_REQUEST',
  'UPLOAD_PRESENTATION_FILE_SUCCESS',
  'UPLOAD_PRESENTATION_FILE_FAILURE',
)<
  {
    fileUploadId: string;
    presentationId: string;
    path: Array<string | number>;
    localUrl: string;
  },
  { fileUploadId: string },
  { fileUploadId: string; error: Error }
>();
